import ScreenshotBuses from "../../../Assets/screenshots/buses.png";
import ScreenshotClarkLake from "../../../Assets/screenshots/clarklake.png";
import ScreenshotCtaMap from "../../../Assets/screenshots/cta-map.png";
import { accessibilityLabels } from "../features/accessibilityLabels";
import { HeroScreenshot } from "./HeroScreenshot";

/**
 * A set of screenshots to show in the hero section of the home page.
 */
export function HeroScreenshots() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 10,
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: 5,
        width: "100%", // Prevent horizontal scrolling

        // Clip the screenshots to a fixed height, cropping at bottom
        height: 400,
        overflow: "hidden",
      }}
    >
      {/* Buses screenshot */}
      <HeroScreenshot
        src={ScreenshotBuses}
        alt={accessibilityLabels.busesScreenshot}
        style={{
          marginRight: -155,
          marginTop: 50,
        }}
      />

      {/* Clark & Lake station screenshot */}
      <HeroScreenshot
        src={ScreenshotClarkLake}
        alt={accessibilityLabels.clarkLakeScreenshot}
        style={{
          zIndex: 1,
        }}
      />

      {/* CTA map screenshot */}
      <HeroScreenshot
        src={ScreenshotCtaMap}
        alt={accessibilityLabels.ctaMapScreenshot}
        style={{
          marginLeft: -155,
          marginTop: 50,
        }}
      />
    </div>
  );
}
